import { userBlocFactory } from './chunk-3ACS42EJ.mjs';
export { userBlocFactory, userOutputSchema as userSchema } from './chunk-3ACS42EJ.mjs';
import { firestore } from './chunk-CBPAVK33.mjs';

// src/user.ts
var userBloc = userBlocFactory({ db: firestore });

export { userBloc };
//# sourceMappingURL=user.mjs.map
//# sourceMappingURL=user.mjs.map